import { ComponentView, ObservableArray } from "binder";
import { ExactTimeViewModel, TimeItem } from "./exactTime-viewModel"

export class ExactTimeView extends ComponentView<ExactTimeViewModel>{
    GetViewUniqueId(): string {
        return "V-D0870D0F-FC01-40C4-B9A8-686966C8FB90"
    }
    loadHtml(): string {
        let element = require('./exactTime.html').default;
        let style = require('./exactTime.less');
        return element;
    }
    constructor() {
       super();
    }
    public set items(v: ObservableArray<TimeItem>) { this._items = v; } public get items(): ObservableArray<TimeItem> { return this._items;} private _items: ObservableArray<TimeItem>;
    public set selectedtime(v: string) { this._selectedtime = v; } public get selectedtime(): string { return this._selectedtime;} private _selectedtime: string;
    public set selecteditem(v: TimeItem) { this._selecteditem = v; } public get selecteditem(): TimeItem { return this._selecteditem;} private _selecteditem: TimeItem;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;
}
